export const UPDATE_GST_BILLING_DETAILS = "UPDATE_GST_BILLING_DETAILS";
export const GET_GST_BILLING_DETAILS = "GET_GST_BILLING_DETAILS";
export const SAVE_GST_BILLING_DETAILS = "SAVE_GST_BILLING_DETAILS";
export const UPDATE_SAME_HSN = "UPDATE_SAME_HSN";
export const TOGGLE_UPLOAD_CATALOG_SHEET_MODAL = "TOGGLE_UPLOAD_CATALOG_SHEET_MODAL";
export const TOGGLE_TERMS_AND_CONDITIONS_CHECKED_STATE = "TOGGLE_TERMS_AND_CONDITIONS_CHECKED_STATE";
export const VERIFY_GST = "VERIFY_GST";
export const ENABLE_OR_DISABLE_GST = "ENABLE_OR_DISABLE_GST";
export const DOWNLOAD_GST_REPORT = "DOWNLOAD_GST_REPORT";
